import { ActiveEmployees } from "./ActiveEmployeeList";
import { ActiveTempReport } from "./ActiveTempReport";
import { ActiveEmployeesAtClosedLocation } from "./ClosedLocation";
import { EmployeesWithTerminatedSupervisors } from "./EmployeesWithTerminatedSupervisors";
import { ActiveEmployeesNoEmailAddress } from "./NoEmailAddress";
import { NoEmployeeId } from "./NoEmployeeId";
import { PendingTerminationReport } from "./PendingTerminationReport";
import { AllTressEmployees } from "./TressEmployees";
import { FranchiseeEmployees } from "./FranchiseeEmployees";
import { FranchiseeOwners } from "./FranchiseeOwners";
import { UltiproPeople } from "./UltiproPeople";
import {
  EMPLOYEEREPORTS_PERMISSIONS,
  EMPLOYEEREPORTS_ROUTEPATHS,
} from "./permission";
import { ActiveSPLCEmployees } from "./ActiveSPLCEmployees";

export const EmployeeSideBar = [
  {
    title: "Active Employees",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveEmployees_Reports,
    component: ActiveEmployees,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_active_employee_view,
  },
  {
    title: "Active SPLC Employees",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveSPLCEmployees_Reports,
    component: ActiveSPLCEmployees,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_active_splc_employee_view,
  },
  {
    title: "Active Employees No Email Address",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveEmployeesNoEmailAddress_Report,
    component: ActiveEmployeesNoEmailAddress,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_active_employee_no_emailaddress_view,
  },
  {
    title: "Active Employees at Closed Locations",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveEmployeesAtClosedLocations_Report,
    component: ActiveEmployeesAtClosedLocation,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_active_employee_closed_location_view,
  },
  {
    title: "Active Employees No Employee ID ",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveEmployeesNoEmployeeId_Report,
    component: NoEmployeeId,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_active_employee_no_employeeid_view,
  },
  {
    title: "Employees with Terminated Supervisors",
    to: EMPLOYEEREPORTS_ROUTEPATHS.EmployeesWithTerminatedSupervisors_Report,
    component: EmployeesWithTerminatedSupervisors,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_with_terminated_supervisor_view,
  },
  {
    title: "Active Temp Report",
    to: EMPLOYEEREPORTS_ROUTEPATHS.ActiveTempReport_Report,
    component: ActiveTempReport,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_activetemp_view,
  },
  {
    title: "Pending Termination Report",
    to: EMPLOYEEREPORTS_ROUTEPATHS.PendingTermination_Report,
    component: PendingTerminationReport,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_pending_termination_view,
  },
  {
    title: "All Tress Employees",
    to: EMPLOYEEREPORTS_ROUTEPATHS.AllTressEmployees_Report,
    component: AllTressEmployees,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_all_tressemployees_view,
  },
  {
    title: "Franchisee Employees",
    to: EMPLOYEEREPORTS_ROUTEPATHS.FranchiseeEmployees_Report,
    component: FranchiseeEmployees,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_franchisee_employees_view,
  },
  {
    title: "Franchisee Owners",
    to: EMPLOYEEREPORTS_ROUTEPATHS.FranchiseeOwners_Report,
    component: FranchiseeOwners,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_franchisee_owners_view,
  },
  {
    title: "Ultipro People",
    to: EMPLOYEEREPORTS_ROUTEPATHS.UltiproPeople_Report,
    component: UltiproPeople,
    permission:
      EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_ultipro_people_view,
  },
];
